<style scoped>
.modal ::v-deep .modal-window {
    box-shadow: 0em 0em 1em 0.5em #fcbc00;
    @apply border-primary;
}
.modal ::v-deep .btn-confirm {
    @apply bg-primary text-white border-0;
}
.modal ::v-deep .btn-cancel {
    @apply bg-white text-primary border-2 border-primary;
}
.modal.modal-secondary ::v-deep .modal-window {
    box-shadow: 0em 0em 1em 0.5em #678f89;
    @apply border-secondary;
}
.modal.modal-secondary ::v-deep .btn-confirm {
    @apply bg-secondary text-white border-0;
}
.modal.modal-secondary ::v-deep .btn-cancel {
    @apply bg-white text-secondary border-2 border-secondary;
}

@screen sm {
    .modal ::v-deep .modal-window {
        @apply max-w-lg;
    }
    .modal.modal-sm ::v-deep .modal-window {
        @apply max-w-sm;
    }
    .modal.modal-md ::v-deep .modal-window {
        @apply max-w-md;
    }
    .modal.modal-xl ::v-deep .modal-window {
        @apply max-w-xl;
    }
    .modal.modal-2xl ::v-deep .modal-window {
        @apply max-w-2xl;
    }
    .modal.modal-3xl ::v-deep .modal-window {
        @apply max-w-3xl;
    }
    .modal.modal-4xl ::v-deep .modal-window {
        @apply max-w-4xl;
    }
    .modal.modal-5xl ::v-deep .modal-window {
        @apply max-w-5xl;
    }
    .modal.modal-6xl ::v-deep .modal-window {
        @apply max-w-6xl;
    }
}
</style>
<style>
body.modal-opened {
    overflow: hidden;
}
</style>

<template>
    <div class="modal fixed inset-0 flex items-center justify-center z-50">
        <div
            class="absolute opacity-50 bg-black inset-0 z-10"
            @click="$emit('backdrop')"
        ></div>
        <div
            class="modal-window bg-white w-full z-20 mx-2 p-4 border-4 shadow rounded-lg relative"
        >
            <slot></slot>
            <div
                class="flex justify-end mt-8"
                v-if="type === 'confirm' || type === 'alert'"
            >
                <button
                    class="btn btn-cancel px-8 py-2 mr-2"
                    v-if="showCancel"
                    @click="cancel"
                >
                    {{ theCancelText }}
                </button>
                <button
                    class="btn btn-confirm px-8 py-2 font-black"
                    @click="confirm"
                >
                    <div
                        class="flex items-center inset-0 justify-center"
                        v-if="status === 'loading'"
                    >
                        <spinner class="spinner-sm" />
                    </div>
                    <div v-else>
                        {{ theConfirmText }}
                    </div>
                </button>
            </div>
            <div v-if="showDismiss" class="flex justify-center mt-4">
                <div
                    class="icon icon-scale rounded-full bg-red text-white"
                    @click="$emit('backdrop')"
                >
                    <closeSvg />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import closeSvg from '../assets/svg/close.svg';
import spinner from '@/components/spinner.vue';

let modalOpened = 0;
export default {
    components: {
        closeSvg,
        spinner
    },
    props: {
        type: { type: String, default: 'confirm' },
        cancelText: { type: String },
        confirmText: { type: String },
        showCancel: { type: Boolean, default: true },
        showDismiss: { type: Boolean, default: false }
    },
    data: () => ({
        status: undefined
    }),
    mounted() {
        modalOpened += 1;
        document.body.classList.add('modal-opened');

        /*eslint-disable no-empty*/
        try {
            this.$root.$el.appendChild(this.$el);
        } catch (e) {
            /* eslint-disable no-console */
            console.error('remove modal e', e);
        }
    },
    beforeDestroy() {
        modalOpened -= 1;
        /* eslint-disable no-console */
        console.log('modalOpened', modalOpened);
        if (modalOpened <= 0) {
            document.body.classList.remove('modal-opened');
        }

        /*eslint-disable no-empty*/
        try {
            this.$root.$el.removeChild(this.$el);
        } catch (e) {}
    },
    computed: {
        theCancelText() {
            if (this.cancelText) {
                return this.cancelText;
            }
            return this.$t('common.cancel');
        },
        theConfirmText() {
            if (this.confirmText) {
                return this.confirmText;
            }
            return this.$t(
                this.type === 'confirm' ? 'common.confirm' : 'common.ok'
            );
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        confirm() {
            this.$emit('confirm');
        },
        updateSaveStatus(status) {
            this.status = status;
        }
    }
};
</script>
